export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13782.8afdb96d.jpg";